import api from "./httpClient";


// /**
//  * Wywołuje /Address/Csv i zwraca cały axios response (headers + blob).
//  * @param {Object} filters - np. obiekt z URLSearchParams
//  * @param {AbortSignal} [signal]
//  * @returns {Promise<import('axios').AxiosResponse<Blob>>}
//  */
// export function exportAddressesCsv(filters, signal) {
//   return api.get("/Address/Csv", {
//     params: filters,
//     responseType: "blob",
//     signal,
//   });
// }

  
export const addressCache = new Map(); // key: id (string), value: address object

/**
 * Fetch multiple addresses by IDs or if falls GET /id.
 */
export async function getAddressesByIds(ids) {
    if (!Array.isArray(ids)) return [];
    const uniqueIds = [...new Set(ids.map(String).filter(id => id && !isNaN(Number(id))))];
    if (uniqueIds.length === 0) return [];

    // Gather cached values and remaining IDs to fetch
    const cached = [];
    const toFetch = [];
    uniqueIds.forEach(id => {
        if (addressCache.has(id)) {
            cached.push(addressCache.get(id));
        } else {
            toFetch.push(id);
        }
    });

    let fetched = [];
    if (toFetch.length) {
        // Attempt batch endpoint first
        try {
            const batchResp = await api.get('/Address/ByIds', { params: { ids: toFetch.join(',') } });
            let data = batchResp.data;
            if (Array.isArray(data)) {
                fetched = data;
            } else if (data && Array.isArray(data.items)) {
                fetched = data.items;
            }
        } catch (batchErr) {
            // Fallback to individual requests
            fetched = await Promise.all(
                toFetch.map(async id => {
                    try {
                        const resp = await api.get(`/Address/${id}`);
                        return resp.data;
                    } catch (e) {
                        return { id, __missing: true };
                    }
                })
            );
        }
    }

    // Update cache
    fetched.forEach(item => {
        if (item && item.id != null) {
            addressCache.set(String(item.id), item);
        }
    });

    const allMap = new Map();
    [...cached, ...fetched].forEach(item => {
        if (item && item.id != null) allMap.set(String(item.id), item);
    });
    const result = uniqueIds.map(id => allMap.get(id) || { id, __missing: true });
    return result;
}

const getNumericBranchId = (record) => {
    if (!record || typeof record !== "object") return undefined;

    const rawBranchId =
        record.branchId ??
        record.BranchId ??
        record.branchID ??
        record.BranchID ??
        record.branch_id ??
        record.terminalId ??
        record.TerminalId;

    const numericBranchId = Number(rawBranchId);
    return Number.isFinite(numericBranchId) && numericBranchId > 0
        ? numericBranchId
        : undefined;
};

/**
 * Resolve common branchId for all records matching filters in /Address/List.
 * Returns undefined if records have different branchId, missing branchId, or no records.
 */
export async function resolveCommonBranchIdForFilters(filters = {}, signal) {
    const normalizedFilters = Object.entries(filters || {}).reduce((acc, [key, value]) => {
        if (value === undefined || value === null || value === "") return acc;
        acc[key] = value;
        return acc;
    }, {});

    const response = await api.get('/Address/List', {
        params: normalizedFilters,
        signal,
    });

    const payload = response?.data;
    const items = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.items)
            ? payload.items
            : [];

    let commonBranchId;
    let hasAnyRecord = false;

    for (const item of items) {
        hasAnyRecord = true;
        const itemBranchId = getNumericBranchId(item);
        if (!itemBranchId) return undefined;

        if (commonBranchId === undefined) {
            commonBranchId = itemBranchId;
        } else if (commonBranchId !== itemBranchId) {
            return undefined;
        }
    }

    return hasAnyRecord ? commonBranchId : undefined;
}

/**
 * POST /api/Address/ScheduleUpdate
 * @param {object} payload InformationUpdateDto
 * @param {AbortSignal} [signal]
 * @param {number | undefined} [branchId]
 */
export function scheduleAddressUpdate(payload, signal, branchId) {
    const numericBranchId = Number(branchId);
    const hasBranchId = Number.isFinite(numericBranchId) && numericBranchId > 0;

    return api.post("/Address/ScheduleUpdate", payload, {
        signal,
        params: hasBranchId ? { branchId: numericBranchId } : undefined,
        headers: { "Content-Type": "application/json" },
    });
}

/**
 * PATCH /api/Address/Update
 * @param {object} payload InformationUpdateDto
 * @param {AbortSignal} [signal]
 * @param {number | undefined} [branchId]
 */
export function updateAddress(payload, signal, branchId) {
    const numericBranchId = Number(branchId);
    const hasBranchId = Number.isFinite(numericBranchId) && numericBranchId > 0;

    return api.patch("/Address/Update", payload, {
        signal,
        params: hasBranchId ? { branchId: numericBranchId } : undefined,
        headers: { "Content-Type": "application/json" },
    });
}



const addressApi = {
//    exportAddressesCsv,
    getAddressesByIds,
    resolveCommonBranchIdForFilters,
    scheduleAddressUpdate,
    updateAddress
};

export default addressApi;